import Frontpage from './frontpage';

export default Frontpage;
